<template>
	<hr class="menu-divider" />
</template>

<style scoped lang="scss">
	.menu-divider {
		display: flex;
		border-width: thin 0 0;
		border-style: solid;
		border-color: var(--color-neutral-200);
		margin: 0;
	}
</style>
